import { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { GoogleIcon } from '../../icons/Google.icon';

type Props = {
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
};

export const GoogleButton = ({ onClick }: Props) => {
  const { t } = useTranslation(['entry']);

  return (
    <button
      type="button"
      onClick={onClick}
      className="flex items-center justify-center px-5 py-2.5 rounded text-sm hover:!bg-gray-200 border border-gray-300 font-medium"
    >
      <GoogleIcon className="mr-2 h-5 inline" />
      <span>{t('continue_with', { value: 'Google' })}</span>
    </button>
  );
};
